import React, { Component } from 'react';
import moment from 'moment'
import { Icon, Table, Tabs, Button, message, Modal, Form, Input, Spin, Select, Tooltip, DatePicker, Progress, } from 'antd'
import Bookmark from "../remoteApply/bookmark";
import { getTypicalCasesBaseInfo, cancelCollect, getTypicalCasesList, getPatientSourceList, printPic } from '@/request/api'
import starback from "../../assets/image/starback.png"
import "./typicalCases.scss";
import EditTable from '../../components/editTable/index';
import { fileStatus, refreshTime, getCommonColumnInfoFn, getFileStatus, requestErrorLog } from '../../common/util'
import { sendMessage, receiveMessage, initWebSocket } from '@/request/websocket'
const { TabPane } = Tabs;
const { confirm } = Modal;
const { Option } = Select;
// 开始日期-结束日期
const defaultSelectDate = {
  startDate: moment().startOf("day").subtract(7, "days"),
  endDate: moment().endOf(-1, "day"),
};

class TypicalCases extends Component { // 典型病例
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      PageNo: 1,
      PageSize: 10,
      RowCount: 0,
      currentIndex: 1,
      showKey: "1",
      bookmarkVisible: false,
      percent: 0,
      refreshTimeNum: 0,
      selectExamUid: "",
      downloadMsg: "",
      transmiRate: 0,
      selectExamUids: [],
      downloadError: [],
      loadingList: [],
      selectedRowKeys: [],
      selections: [],
      initCommonColumn: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 60,
          isShow: true,
          render: (text, record, index) => {  //生成序号
            return (
              <span>{(this.state.currentIndex - 1) * 10 + (index + 1)}</span>
            )
          },
        },
        {
          title: "传输状态",
          dataIndex: "Progress",
          key: "Progress",
          align: 'center',
          width: 160,
          isShow: true,
          render: (text, record) => {
            if (this.state.loadingList.some(item => item.EXAM_UID === record.EXAM_UID)) {
              let value = this.state.loadingList.filter(item => item.EXAM_UID === record.EXAM_UID)[0];
              if (value.RETURN_RATE) {
                return <div>
                  <p style={{ textAlign: 'left' }}>{value.RETURN_MSG}</p>
                  {value.RETURN_RATE && value.RETURN_MSG !== '已报告' ? <Progress percent={parseInt(value.RETURN_RATE)} size="small" /> : null}
                </div>
              } else {
                return <div>{value.RETURN_MSG}</div>
              }
            } else {
              return <div></div>
            }
          }
        },
        {
          title: "检查类型",
          dataIndex: "EXAM_CLASS",
          key: "EXAM_CLASS",
          align: 'center',
          width: 80,
          ellipsis: true,
          isShow: true,
          render: (text) => {
            return (
              <span>{text === 'Holter' ? '动态心电' : text === 'ECG' ? '静息心电' : text === 'BloodPressure' ? '动态血压' : ''}</span>
            )
          }
        },
        {
          title: "姓名",
          dataIndex: "NAME",
          key: "NAME",
          align: 'center',
          width: 120,
          ellipsis: true,
          isShow: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "性别",
          dataIndex: "SEX_NAME",
          key: "SEX_NAME",
          align: 'center',
          width: 70,
          isShow: true,
        },
        {
          title: "年龄",
          dataIndex: "EXAM_AGE",
          key: "EXAM_AGE",
          align: 'center',
          width: 60,
          isShow: true,
          render: (text, record) => {
            return record.EXAM_AGE + record.AGE_UNIT
          }
        },
        {
          title: "病区",
          dataIndex: "ROOM_NO",
          key: "ROOM_NO",
          align: 'center',
          width: 120,
          isShow: true,
        },
        {
          title: "床号",
          dataIndex: "BED_NO",
          key: "BED_NO",
          align: 'center',
          width: 80,
          isShow: true,
        },
        {
          title: "门诊号",
          dataIndex: "OUTP_NO",
          key: "OUTP_NO",
          align: 'center',
          width: 120,
          isShow: true,
        },
        {
          title: "住院号",
          dataIndex: "INP_NO",
          key: "INP_NO",
          align: 'center',
          width: 120,
          isShow: true,
        },
        {
          title: "患者来源",
          dataIndex: "PATIENT_SOURCE_NAME",
          key: "PATIENT_SOURCE_NAME",
          align: 'center',
          width: 120,
          isShow: true,
        },
        {
          title: "申请医院",
          dataIndex: "APPLY_HOSPITAL_NAME",
          key: "APPLY_HOSPITAL_NAME",
          align: 'center',
          width: 140,
          isShow: true,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "申请人",
          dataIndex: "APPLY_DOCTOR_NAME",
          key: "APPLY_DOCTOR_NAME",
          align: 'center',
          width: 100,
          isShow: true,
        },
        {
          title: "申请会诊时间",
          dataIndex: "APPLY_DATETIME",
          key: "APPLY_DATETIME",
          align: "center",
          width: 160,
          isShow: true,
          sorter: (a, b) =>
            new Date(a.APPLY_DATETIME).getTime() -
            new Date(b.APPLY_DATETIME).getTime(),
          render: (val) => (
            <span>{val && moment(val).format("YYYY-MM-DD HH:mm:ss")}</span>
          ),
        },
        {
          title: "会诊医院",
          dataIndex: "CONSULTATION_HOSPITAL_NAME",
          key: "CONSULTATION_HOSPITAL_NAME",
          align: 'center',
          width: 140,
          ellipsis: true,
          isShow: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "会诊人",
          dataIndex: "CONSULTATION_DOCTOR_NAME",
          key: "CONSULTATION_DOCTOR_NAME",
          align: 'center',
          width: 120,
          ellipsis: true,
          isShow: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "完成会诊时间",
          dataIndex: "CONSULTATION_DATE",
          key: "CONSULTATION_DATE",
          align: 'center',
          width: 160,
          isShow: true,
          sorter: (a, b) => new Date(a.CONSULTATION_DATE).getTime() - new Date(b.CONSULTATION_DATE).getTime(),
          render: (val) => (
            <span>
              {val && moment(val).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          ),
        },
        {
          title: "检查结论",
          dataIndex: "CONCLUSIONS",
          key: "CONCLUSIONS",
          align: 'center',
          width: 160,
          ellipsis: true,
          isShow: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "临床诊断",
          dataIndex: "CLIN_DIAG",
          key: "CLIN_DIAG",
          align: 'center',
          width: 160,
          ellipsis: true,
          isShow: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: '收藏书签',
          dataIndex: 'COLLECT_TAG',
          key: 'COLLECT_TAG',
          align: 'center',
          width: 120,
          ellipsis: true,
          isShow: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        }
      ],
      commonColumn: [],
      showColumn: false,
    }
  }

  keepAlive = () => {
    let params = {
      TYPE: 'HOLTER',
      PARAM: 'GET_FILE_STATES',
    }
    sendMessage(params)
    receiveMessage(data => {
      if (data.RETURN_VALUE === '文件状态') {
        let arr = getFileStatus(data);
        this.setState({
          loadingList: arr
        })
      } else {
        if (data.EXAM_UID !== '') {
          this.getTransferStatus(data)
        }
      }
    })
  }


  async componentDidMount() {
    this.allBasicData()
    this.initTabsChange()
    this.getCommonColumnInfo()
    let refreshTimeNum = refreshTime(this)
    this.setState({
      refreshTimeNum
    }, () => {
      this.refreshTimer = setInterval(() => refreshTime(this, this.handleHospitalSubmit), this.state.refreshTimeNum * 1000 * 60 / 200)
    })
    await initWebSocket()
    this.keepAlive()
  }

  componentWillUnmount() {
    clearInterval(this.refreshTimer)
  }

  canOperation = (data) => {
    let loadingList = this.state.loadingList;
    let status = true
    data.forEach(elem => {
      loadingList.forEach(item => {
        if (item.EXAM_UID === elem.EXAM_UID) {
          status = fileStatus(item.RETURN_MSG);
        }
      })
    })
    if (!status) {
      message.error('该病例正在传输中，无法执行此操作')
      return false;
    } else {
      return true
    }
  }

  getTransferStatus = (value) => {
    let loadingList = this.state.loadingList;
    if (loadingList.some(item => item.EXAM_UID === value.EXAM_UID)) {
      loadingList.forEach((item, index) => {
        if (item.EXAM_UID === value.EXAM_UID) {
          loadingList.splice(index, 1, value)
        }
      })
    } else {
      loadingList.push(value)
    }
    this.setState({
      loadingList,
      tabsloading: false
    })
  }

  // 典型病例开始报告
  telemedicineFn = (record) => {
    if (!this.canOperation([record])) {
      return;
    }
    this.setState({
      tabsloading: true,
    })
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.downloadHolter(record, userInfo)
  }

  //单纯的下载holter文件
  downloadHolter = (record, userInfo) => {
    const settingData = JSON.parse(localStorage.getItem("settingValues")) || {}
    let params = {
      TYPE: record.EXAM_CLASS === 'Holter' ? 'HOLTER' : record.EXAM_CLASS === 'ECG' ? 'ECG' : 'BLOOD',
      PARAM: record.CONSULTATION_STATUS === "未申请" ? 'OUR_HOSPITAL' : 'REMOTE_HOSPITAL',
      EXAM_UID: record.EXAM_UID,
      NAME: record.NAME,
      SERVER: window.g.baseURL,
      USER_INFO: userInfo,
      PRIVILEGE: 2,
      PRINT_HOSPITAL: settingData.printingType,
      PRINT_SIGN_TYPE: settingData.signatureType
    }
    sendMessage(params)
    receiveMessage(data => {
      this.setState({
        tabsloading: false,
      })
      if (data.RETURN_VALUE !== 'RV_SUC_OPEN' && data.RETURN_VALUE !== 'RV_SUC_PROGRAM_EXIT') {
        this.getTransferStatus(data)
      }
    })
  }

  // 双击事件
  handleDoubleClicks = (record) => {
    const roleList = JSON.parse(localStorage.getItem('roleList')) || []
    if (roleList.indexOf('查看报告') > -1) {
      this.telemedicineFn(record)
    } else if (roleList.indexOf('PDF查看') > -1) {
      let EXAM_UID = record.EXAM_UID
      printPic(EXAM_UID).then((res) => {
        if (res && res.Status === 1) {
          const picUrl = window.g.baseURL + "/" + res.Result
          window.open(picUrl);					// 打开pdf文件
        } else {
          requestErrorLog(EXAM_UID, '典型病打开PDF接口报错', 0, true)
          message.error("暂无权限，请联系管理员")
        }
      })
    }
  }

  setRowClassName = (record) => {
    return record === this.state.rowData ? 'clickRowStyl' : '';
  }

  allBasicData = () => { // 字典->用户基本数据
    let params = { "pageNo": 1, "pageSize": 10, "NAME": "" }
    getPatientSourceList(params).then(res => {
      console.log(res, 'res1')
      if (res && res.Status === 1) {
        this.setState({
          sourceType: res.Result.dataList
        })
      } else {
        requestErrorLog('', '典型病例获取患者来源接口报错', 0, true)
      }
    })
    getTypicalCasesBaseInfo().then((res) => {
      if (res && res.Status === 1) {
        const basicsdata = res.Result.basicsdata
        const department = res.Result.department;
        Object.values(basicsdata).forEach((item) => {
          switch (item.name) {
            case "检查类型":
              this.setState({
                inspectionType: item
              })
              break;
            default:
              break;
          }
        })
        for (var s = 0; s < department.length; s++) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
          if (userInfo.HOSPITAL_NAME === department[s].name) {
            const departmentList = department[s].dept;
            this.setState({
              departmentList: departmentList,
            });
          }
        }
      } else {
        requestErrorLog('', '典型病例获取基础信息接口报错', 0, true)
      }
    })
  };

  handleCancelCollection = () => { // 取消收藏
    if (this.state.selections.length === 1) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      confirm({
        title: '取消收藏',
        content: '确认将该报告取消收藏吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          let params = {
            Type: "PersonCasesUpdate", // 患者信息
            hospital_Code: userInfo.HOSPITAL_CODE,
            USER_UID: userInfo.USER_UID,
            EXAM_UID: this.state.selections[0].EXAM_UID
          }
          cancelCollect(params).then((res) => {
            if (res && res.Status === 1) {
              message.success("取消收藏成功！");
              this.initTabsChange()
            } else {
              requestErrorLog(this.state.selections[0].EXAM_UID, '典型病例收藏接口报错', 0, true)
              message.error("取消收藏失败！");
            }
          })
        },
      });
    } else {
      message.warning("请选择一条要取消收藏的病例信息！")
    }
  }

  handleHospitalSubmit = () => { // 列表查询
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.props.form.validateFields((err, values) => {
      if (values.startTime > values.endTime) {
        message.error('开始时间不得大于结束时间')
        return;
      }
      if (!err) {
        let params = {
          Type: "TypicalCasesData", // 查询
          USER_UID: this.state.showKey === "1" ? userInfo.USER_UID : "",
          hospital_Code: userInfo.HOSPITAL_CODE,
          hospitalPatientName: values.hospitalPatientName || "",
          CONSULTATION_STATUS: '',//会诊状态
          hospitalDoctor: values.hospitalDoctor || "", //开单医生
          hospitalItemDoctor: values.hospitalItemDoctor || "",//开单医生模糊查询
          COLLECT_TAG: values.COLLECT_TAG,
          hospitalReportStatus: "",
          exam_class: values.exam_class || "",
          hospitalNumber: values.hospitalNumber || "",
          hospitalItemNumber: values.hospitalItemNumber || "",
          hospitalApplyDepartment: values.hospitalApplyDepartment || "",
          hospitalApply: values.hospitalApply || "",
          hospitalItemApply: values.hospitalItemApply || "",
          hospitalPatientSource: values.hospitalPatientSource || "",
          hospitalDateTime: values.hospitalDateTime || "",
          hospitalConclusion: values.hospitalConclusion || "",
          hospitalItemDateTime: [moment(values.startTime).format('YYYY-MM-DD'), moment(values.endTime).format('YYYY-MM-DD')],
          PageSize: this.state.PageSize,
          PageNo: this.state.PageNo,
        }
        getTypicalCasesList(params).then((res) => {
          if (res && res.Status === 1) {
            const data = res.Result;
            this.setState({
              tableData: data,
              RowCount: res.ResponseModel.RowCount,
              tabsloading: false
            });
          } else {
            requestErrorLog('', '典型病例列表查询接口报错', 0, true)
            message.error("请检查网络连接");
          }
        });
      }
    });
  }

  handleChangeReset = () => { // 重置
    this.props.form.resetFields();
  }

  handleEditTag = () => { // 修改书签
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (this.state.selections.length === 1) {
      if (this.state.selections[0].TAG_USER_UID.trim() === userInfo.USER_UID || this.state.selections[0].COLLECT_TAG === '') {
        this.setState({
          bookmarkVisible: true,
          submitType: "edit",
          typicalRowData: this.state.selections[0],
          bookmarkdetail: this.state.selections[0].COLLECT_TAG
        });
      } else {
        message.warning("此用户无权限修改");
        return;
      }
    } else {
      message.warning("请选择一条要修改书签的病例信息！")
    }

  }

  initTabsChange = () => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.setState({
      selectedRowKeys: [],
      selections: []
    })
    if (this.state.showKey === "1") {
      this.handleHospitalSubmit(userInfo.USER_UID)
    }
    if (this.state.showKey === "2") {
      this.handleHospitalSubmit("")
    }
  }

  //每次切换页码的时候,更新之前初始化的页码
  onChangePage = (page, pageSize) => {
    this.setState({
      PageNo: page
    }, () => {
      this.initTabsChange();
    })
  }

  handleTabKey = (key) => { // 切换tabPane
    this.setState({
      showKey: key,
      PageNo: 1,
      PageSize: 10,
      selectedRowKeys: [],
      tabsloading: true
    }, () => {
      this.handleHospitalSubmit()
    })
  }

  searchListFn = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10,
    }, () => {
      this.handleHospitalSubmit()
    })
  }

  // 只能选择今天跟今天之前的日期
  disabledDate(current) {
    return current > moment().subtract(0, "day");
  }

  onSelectChange = (selectedRowKeys, selections) => {
    this.setState({
      selectedRowKeys: selectedRowKeys,
      selections: selections
    })
  }

  onClickRow = (record) => { // 单击行事件 
    let arraylist = []
    arraylist.push(record.EXAM_UID);
    let rowsData = [];
    rowsData.push(record);
    this.setState({
      selectedRowKeys: arraylist,
      selections: rowsData,
    });
  }
  //双击表头出现设置框
  handleHeader = () => {
    this.setState({
      showColumn: true
    });
  }
  //获取、更新表头设置
  getCommonColumnInfo = (newTabData) => { //获取、更新表头设置
    newTabData = newTabData || JSON.parse(localStorage.getItem("typicalTabSetting")) || this.state.initCommonColumn;
    let commonColumn = getCommonColumnInfoFn(this.state.initCommonColumn, newTabData, 'typicalTabSetting')
    this.setState({
      commonColumn,
    })
  }
  render() {
    const { form: { getFieldDecorator } } = this.props;
    const { tableData, tabsloading, departmentList, selectedRowKeys, inspectionType, sourceType, typicalRowData, selections, percent, bookmarkVisible, bookmarkdetail, submitType, showKey, commonColumn } = this.state;
    const settingData = JSON.parse(localStorage.getItem("settingValues"))
    return (
      <>
        <div className="tabs_wrap">
          <div onClick={this.handleEditTag}>
            <Icon type="solution" className="icon" />
            <p>修改书签</p>
          </div>
          {
            showKey === '1' ?
              <div onClick={this.handleCancelCollection}>
                {/* <Icon type="desktop" className="icon" /> */}
                <img src={starback} alt='' style={{ width: '26px', marginLeft: '31px', marginBottom: '5px', marginTop: '2px' }}></img>
                <p>取消收藏</p>
              </div>
              : null
          }
        </div>
        {
          bookmarkVisible ?
            <Bookmark
              visible={bookmarkVisible}
              submitType={submitType}
              rowData={typicalRowData}
              refreshTable={this.initTabsChange}
              bookmarkdetail={bookmarkdetail}
              isEdit={false}
              onRef={(ref) => {
                this.setState({ bookmarkVisible: ref })
              }
              }>
            </Bookmark>
            : null
        }
        {
          this.state.showColumn ?
            <EditTable
              visible={this.state.showColumn}
              setTabData={JSON.parse(localStorage.getItem("typicalTabSetting")) || this.state.initCommonColumn}
              updateParent={this.getCommonColumnInfo}
              onRef={(ref) => { this.setState({ showColumn: ref.showColumn }) }} /> : null
        }
        <Form layout="inline" className="commonCase">
          <div>
            <Form.Item label="患者姓名">
              {getFieldDecorator("hospitalPatientName", { initialValue: "" })(
                <Input />
              )}
            </Form.Item>
            <Form.Item label="标签">
              {getFieldDecorator('COLLECT_TAG', { initialValue: "" })(<Input />)}
            </Form.Item>
            <Form.Item label="检查类型">
              {getFieldDecorator('exam_class', { initialValue: "" })(
                <Select>
                  <Option value="">全部</Option>
                  {inspectionType && inspectionType.dt.map((item) => {
                    return <Option value={item.DIC_CODE} key={item.DIC_CODE}>{item.DIC_NAME}</Option>
                  })}
                </Select>
              )}
            </Form.Item>
            <Form.Item className="mark" label={getFieldDecorator("hospitalNumber", { initialValue: (settingData && settingData.hospitalNumber) || "病历号" })(
              <Select>
                <Option value="病历号">病历号：</Option>
                <Option value="住院号">住院号：</Option>
                <Option value="门诊号">门诊号：</Option>
                <Option value="申请号">申请号：</Option>
              </Select>
            )}
            >
              {getFieldDecorator("hospitalItemNumber", { initialValue: "" })(
                <Input />
              )}
            </Form.Item>
          </div>

          <Form.Item label="申请科室">
            {getFieldDecorator("hospitalApplyDepartment", { initialValue: "", })(
              <Select>
                <Option value="">全部</Option>
                {departmentList && departmentList.map((item) => (
                  <Option key={item.DEPT_CODE} value={item.DEPT_CODE}>
                    {item.DEPT_NAME}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>

          <Form.Item label="患者来源">
            {getFieldDecorator("hospitalPatientSource", { initialValue: "" })(
              <Select>
                <Option value="">全部</Option>
                {sourceType && sourceType.map((item) => {
                  return <Option value={item.PATIENT_SOURCE_CODE} key={item.PATIENT_SOURCE_CODE}>{item.PATIENT_SOURCE_NAME}</Option>
                })}
              </Select>
            )}
          </Form.Item>

          <Form.Item className="mark dateTime"
            label={getFieldDecorator("hospitalDateTime", { initialValue: (settingData && settingData.hospitalDateTime) || "创建日期" })(
              <Select>
                <Option value="申请日期">创建日期：</Option>
                <Option value="远程申请日期">申请会诊日期：</Option>
                <Option value="检查日期">检查日期：</Option>
                <Option value="报告日期">报告日期：</Option>
              </Select>
            )}
          >
            {/* {getFieldDecorator("hospitalItemDateTime", {
              initialValue: [defaultSelectDate.startDate, defaultSelectDate.endDate],
            })(
              <RangePicker allowClear={false} disabledDate={this.disabledDate} />
            )} */}
            {getFieldDecorator('startTime', { initialValue: defaultSelectDate.startDate })(
              <DatePicker
                style={{ width: 125 }}
                allowClear={false}
                placeholder='开始日期'
                disabledDate={this.disabledDate}
              />)}
            <span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
            <Form.Item style={{ width: 110 }}>
              {getFieldDecorator('endTime', { initialValue: defaultSelectDate.endDate })(
                <DatePicker
                  style={{ width: 125 }}
                  allowClear={false}
                  placeholder='结束日期'
                  disabledDate={this.disabledDate}
                />)}
            </Form.Item>
          </Form.Item>

          <Form.Item>
            <Button style={{ marginRight: '10px' }} onClick={() => this.searchListFn()}>查询</Button>
            <Button onClick={() => this.handleChangeReset()}>重置</Button>
          </Form.Item>
          <div style={{ position: 'absolute', left: '60%', top: '10%' }}>
            <Progress className="progress" type="circle" strokeColor="#009d96" width={80} percent={percent} format={(percent) => "自动刷新"} />
          </div>
        </Form>
        <Tabs className="eleWrap typicalTd" activeKey={this.state.showKey} type="card" onChange={this.handleTabKey}>
          <TabPane key="1" tab="个人收藏">
            <Spin size="large" spinning={tabsloading} tip="Loading...">
              <Table
                columns={commonColumn}
                dataSource={tableData}
                rowKey={record => record.EXAM_UID}          // 需要修改为唯一的ID！
                scroll={{ x: 380, scrollToFirstRowOnChange: true }}
                pagination={{
                  total: this.state.RowCount,
                  current: this.state.PageNo,
                  onChange: this.onChangePage
                }}
                rowSelection={{
                  selectedRowKeys,
                  selections,
                  onChange: this.onSelectChange,
                }} //分页
                onRow={record => {
                  return {
                    onClick: e => { this.onClickRow(record) }, // 点击行
                    onDoubleClick: e => {
                      this.handleDoubleClicks(record)
                    },
                  }
                }}
                rowClassName={this.setRowClassName}
                onHeaderRow={column => {
                  return {
                    onDoubleClick: e => this.handleHeader(column)
                  }
                }}
              />
            </Spin>
          </TabPane>
          <TabPane key="2" tab="医院收藏">
            <Spin size="large" spinning={tabsloading} tip="Loading...">
              <Table
                columns={commonColumn}
                dataSource={tableData}
                rowKey={record => record.EXAM_UID}          // 需要修改为唯一的ID！
                scroll={{ x: 600, scrollToFirstRowOnChange: true }}
                pagination={{
                  total: this.state.RowCount,
                  current: this.state.PageNo,
                  onChange: this.onChangePage
                }}
                rowSelection={{
                  selectedRowKeys,
                  selections,
                  onChange: this.onSelectChange,
                }}
                onRow={record => {
                  return {
                    onClick: e => { this.onClickRow(record) }, // 点击行
                    onDoubleClick: e => {
                      this.handleDoubleClicks(record)
                    },
                  }
                }}
                rowClassName={this.setRowClassName}
                onHeaderRow={column => {
                  return {
                    onDoubleClick: e => this.handleHeader(column)
                  }
                }}
              />
            </Spin>
          </TabPane>
        </Tabs>
      </>
    )
  }
}

export default Form.create({})(TypicalCases);